import type { ApiError } from "@/api/ApiResult";
import { Alert } from "@/components/ui/Alert/Alert";
import { FormLayout } from "@/components/ui/Form/FormLayout";
import { t } from "@/i18n/translate";
import { renderTitleAndHeader } from "../utils/utils";

interface ApportionmentErrorProps {
  error: ApiError;
}

export function ApportionmentError({ error }: ApportionmentErrorProps) {
  const isError = error.reference === "ApportionmentCommitteeSessionNotCompleted";
  return (
    <FormLayout.Alert>
      <Alert type={isError ? "error" : "warning"}>
        <strong className="heading-md">
          {isError ? t("apportionment.not_yet_available") : t("apportionment.not_possible")}
        </strong>
        <p>{t(`error.api_error.${error.reference}`)}</p>
      </Alert>
    </FormLayout.Alert>
  );
}

interface ApportionmentErrorPageProps {
  sectionTitle: string;
  error: ApiError;
}

export function ApportionmentErrorPage({ sectionTitle, error }: ApportionmentErrorPageProps) {
  return (
    <>
      {renderTitleAndHeader(sectionTitle)}
      <main>
        <article>
          <ApportionmentError error={error} />
        </article>
      </main>
    </>
  );
}
